<template>
  <div id="home-view" class="ps-0 pe-0 position-relative container-fluid pb-4">
    <Header />
    <NavBar />
    <router-view class="pb-4"/>
    <Footer class="position-absolute bottom-0 start-0 end-0 fs-6"/>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"

import Header from "@/components/Header.vue"
import NavBar from "@/components/NavBar.vue"
import Footer from "@/components/Footer.vue"

import { useUserStore } from "@/stores/user"
import { useCategoryStore } from "@/stores/category";

@Options({
  components: {
    Header,
    NavBar,
    Footer
  }
})
export default class Home extends Vue {
  userStore = useUserStore()
  categoryStore = useCategoryStore()

  mounted() {
    if (this.userStore.isAdminOnly && !this.userStore.isAdmin) {
      console.log("Home view push to root")
      this.$router.push('/')
    }
  }
}
</script>

<style lang="stylus">
.form-floating input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-floating input[type="password"] {
  margin-bottom: -1px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}

.gradiant-background {
  linear-gradient(to right, #1B1B1B,#1B1B1B, #535353, #1B1B1B, #1B1B1B);
  background-image: linear-gradient(to right, rgb(27, 27, 27), rgb(27, 27, 27), rgb(83, 83, 83), rgb(27, 27, 27), rgb(27, 27, 27));
  background-position-x: initial;
  background-position-y: initial;
  background-size: initial;
  background-repeat-x: initial;
  background-repeat-y: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  background-color: initial;
}

#home-view {
  min-height: 100%
}

</style>
